<template>
  <div>
    <Toolbar :handle-delete="del">
      <template slot="left">
        <v-toolbar-title v-if="item">{{
          `${$options.servicePrefix} ${item['@id']}`
        }}</v-toolbar-title>
      </template>
    </Toolbar>

    <br />

    <div v-if="item" class="table-intervenanttype-show">
      <v-simple-table>
        <template slot="default">
          <thead>
            <tr>
              <th>Field</th>
              <th>Value</th>

              <th>Field</th>
              <th>Value</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td><strong>{{ $t('nom') }}</strong></td>
              <td>
                                    {{ item['nom'] }}
              </td>
            
              <td><strong>{{ $t('slug') }}</strong></td>
              <td>
                                    {{ item['slug'] }}
              </td>
            </tr>
            
            <tr>
              <td><strong>{{ $t('iconAffichage') }}</strong></td>
              <td>
                                    {{ item['iconAffichage'] }}
              </td>
            
              <td><strong>{{ $t('couleurLabel') }}</strong></td>
              <td>
                                    {{ item['couleurLabel'] }}
              </td>
            </tr>
            
          </tbody>
        </template>
      </v-simple-table>
    </div>

    <Loading :visible="isLoading" />
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import { mapFields } from 'vuex-map-fields';
import Loading from '../../components/Loading';
import ShowMixin from '../../mixins/ShowMixin';
import Toolbar from '../../components/Toolbar';

const servicePrefix = 'IntervenantType';

export default {
  name: 'IntervenantTypeShow',
  servicePrefix,
  components: {
      Loading,
      Toolbar
  },
  mixins: [ShowMixin],
  computed: {
    ...mapFields('intervenanttype', {
      isLoading: 'isLoading'
    }),
    ...mapGetters('intervenanttype', ['find'])
  },
  methods: {
    ...mapActions('intervenanttype', {
      deleteItem: 'del',
      reset: 'reset',
      retrieve: 'load'
    })
  }
};
</script>
